import { companySchema } from "@/schema/Company";
import { documentSchema } from "@/schema/Document";
import { submittedBySchema } from "@/schema/SubmittedBy";
import { AnswerCategory } from "@/schema/console/checking-assessments/AnswerCategory";
import { z } from "zod";

export const answeringAssessmentSchema = z.object({
  id: z.number(),
  submitted_by: submittedBySchema,
  submitted_at: z.coerce.date(),
  company: companySchema,
  company_document_files: z.array(documentSchema),
  answer_categories: z.array(AnswerCategory),
});

export type AnsweringAssessment = z.infer<typeof answeringAssessmentSchema>;
